<div mat-dialog-title fxLayout="column" fxLayoutAlign="space-between flex-start">
    <div fxLayout="row" fxLayoutAlign="space-between top" class="fullwidth">
        <div>
            <p>Modo de solo lectura</p>
        </div>

        <button mat-icon-button mat-dialog-close style="color: #666" [disabled]="switchingUser()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="fullwidth" style="position: relative; margin-top: 5px">
        <mat-form-field subscriptSizing="dynamic" class="search-user w-100-p">
            <input
                matInput
                placeholder="Selecciona la persona a suplantar"
                [(ngModel)]="filterPersonValue"
                (keyup)="filterPersons($event)"
                [disabled]="switchingUser()"
            />
            @if (!personSelected() && filterPersonValue.length === 0) {
                <mat-icon matIconSuffix class="s-18">search</mat-icon>
            }
            @if (filterPersonValue.length > 0) {
                <button
                    matIconSuffix
                    mat-icon-button
                    aria-label="Clear"
                    (click)="clearPerson()"
                    [disabled]="switchingUser()"
                >
                    <mat-icon>close</mat-icon>
                </button>
            }
        </mat-form-field>

        @if (switchingUser()) {
            <div class="readonly-dialog-status" fxLayout="row" fxLayoutAlign="center center">
                <mat-spinner diameter="32"></mat-spinner>
                <span class="ml-12">Iniciando sesión como usuario seleccionado…</span>
            </div>
        }

        @if (!switchingUser() && loadingPersons()) {
            <div class="readonly-dialog-status" fxLayout="row" fxLayoutAlign="center center">
                <mat-spinner diameter="28"></mat-spinner>
                <span class="ml-12">Buscando usuarios…</span>
            </div>
        }

        @if (!switchingUser() && !loadingPersons() && filterPersonValue.length > 2 && persons().length === 0) {
            <p class="readonly-dialog-hint">No se encontraron usuarios con ese criterio.</p>
        }

        @if (!switchingUser() && filterPersonValue.length > 0 && filterPersonValue.length <= 2) {
            <p class="readonly-dialog-hint">Escribe al menos 3 caracteres para buscar.</p>
        }

        @if (persons().length > 0 && !personSelected() && !switchingUser()) {
            <div class="wrap-persons">
                <div class="list-persons">
                    @for (person of persons(); track person.id) {
                        <div
                            fxlayout="row"
                            fxLayoutAlign="flex-start center"
                            class="item-person"
                            (click)="selectPerson(person)"
                        >
                            <div class="person-avatar avatar-50 mr-8" fxLayout="row" fxLayoutAlign="center center">
                                <img
                                    class="img-circle"
                                    [src]="getImagePerson(person.username)"
                                    [title]="person.username"
                                />
                            </div>
                            <div fxLayout="column" class="info-person">
                                <span class="m-0 font-size-14">{{ "@" + person.username }}</span>
                                <span class="m-0 font-size-14"
                                    ><strong>{{ person.displayName }}</strong></span
                                >
                            </div>
                        </div>
                    }
                </div>
            </div>
        }
    </div>
</div>
